class Pricings {
    pricingHtml = `<div class="payment__block"><div class="payment__block__close"></div><div class="payment__block__header">Watch unlimited screen recordings default</div><div class=""><div class="payment-plans__item payment-plans__item--selected" data-plan="mdm_y_182_00"><div class="payment-plans__item__header">Annual <span class="payment-plans__item__header--sub">Best offer</span></div><div class="payment-plans__item__price">$0.5 per day</div><div class="payment-plans__item__subtext">$182 billed annually</div></div><div class="payment-plans__item" data-plan="mdm_q_99_00"><div class="payment-plans__item__header">Quarterly</div><div class="payment-plans__item__price">$0.83 per day</div><div class="payment-plans__item__subtext">$99 billed quarterly</div></div><div class="payment-plans__item" data-plan="mdm_m_45_00"><div class="payment-plans__item__header">Monthly</div><div class="payment-plans__item__price">$1.5 per day</div><div class="payment-plans__item__subtext">$45 billed monthly</div></div></div><a class="payment__block__button"><span class="payment__block__button--icon"></span></a><a class="payment__block__button--credit"><span class="payment__block__button--credit-icon" alt=""></span>Credit Card</a><div class="payment__block__text">Subscription plans cannot be changed later. Selecting the annual plan offers significant savings.</div></div>`
    tierApiUrl = 'https://pay.livescreenapp.com/tier/?'
    constructor() {
        this.fetchPrices()
            .then((data) => {
                return this.updatePrixRender(data)
            })
            .then((prxUpd) => {
                this.pricingHtml = prxUpd
            })
            .catch((err) => console.error('prix===rejected:', err.message))
    }

    async fetchPrices() {
        let tierPrice
        let sessionTier = sessionStorage.getItem('tierPrice')
        if (sessionTier) {
            tierPrice = JSON.parse(sessionTier)
        } else {
            const response = await fetch(this.tierApiUrl)
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`)
            }
            tierPrice = await response.json()
            if (tierPrice) {
                sessionStorage.setItem('tierPrice', JSON.stringify(tierPrice))
            } else {
                throw new Error(`Incorrect tierJson`)
            }
        }
        return tierPrice
    }
    async updatePrixRender(tPrx) {
        let pricingHtml = ''
        let priceContainer = `<div class="payment__block"><div class="payment__block__close"></div><div class="payment__block__header">Watch unlimited screen recordings</div><div class="payment__block-pricing">{{price_list}}</div> <a class="payment__block__button"><span class="payment__block__button--icon"></span></a> <a class="payment__block__button--credit"><span class="payment__block__button--credit-icon" alt=""></span>Credit Card</a> <div class="payment__block__text">Subscription plans cannot be changed later. Selecting the annual plan offers significant savings.</div></div>`
        let priceItem = `<div class="payment-plans__item" data-plan="{{sku}}"><div class="payment-plans__item__header">{{header}}</div><div class="payment-plans__item__price">{{price}}</div><div class="payment-plans__item__subtext">{{subtext}}</div></div>`
        let priceCrossItem = `<div class="payment-plans__item" data-plan="{{sku}}"><div class="payment-plans__item__header">{{header}}</div><div class="payment-plans__item__old" style="text-decoration: line-through"">{{old_price}}</div><div class="payment-plans__item__price">{{price}}</div><div class="payment-plans__item__subtext">{{subtext}}</div></div>`
        let priceList = ''
        let pricings = {
            tier: 1,
            offerData: 0,
            propose: ['a', 's', 'q'],
            data: {
                a: {
                    sku: 'mdm_y_182_00',
                    header: 'Annual',
                    price: '$0.5 per day',
                    subtext: '$182 billed annually',
                },
                s: {
                    sku: 'mdm_s_120_00',
                    header: 'Semi-annual',
                    price: '$0.65 per day',
                    subtext: '$120 billed semiannually',
                },
                q: {
                    sku: 'mdm_q_99_00',
                    header: 'Quarterly',
                    price: '$0.83 per day',
                    subtext: '$99 billed quarterly',
                },
                m: {
                    sku: 'mdm_m_45_00',
                    header: 'Monthly',
                    price: '$1.5 per day',
                    subtext: '$45 billed monthly',
                },
                w: {
                    sku: 'mdm_w_18_00',
                    header: 'Weekly',
                    price: '$2.6 per day',
                    subtext: '$18 billed weekly',
                },
            },
        }
        if (!tPrx || (tPrx.tier && tPrx.tier === pricings.tier)) {
            pricings.propose.forEach((key, value) => {
                if (value === pricings.offerData) {
                    priceItem = priceItem.replace('payment-plans__item', 'payment-plans__item payment-plans__item--selected').replace('{{header}}', '{{header}} <span class="payment-plans__item__header--sub">Best offer</span>')
                }
                priceList += priceItem.replace('{{sku}}', pricings.data.key.sku).replace('{{header}}', pricings.data.key.header).replace('{{price}}', pricings.data.key.price).replace('{{subtext}}', pricings.data.key.subtext)
            })
            pricingHtml = priceContainer.replace('{{price_list}}', priceList)
        } else {
            for (const [key, value] of Object.entries(tPrx.data)) {
                let finPriceItem = priceCrossItem
                if (key === tPrx.offerData) {
                    finPriceItem = finPriceItem.replace('payment-plans__item', 'payment-plans__item payment-plans__item--selected').replace('{{header}}', '{{header}} <span class="payment-plans__item__header--sub">Best offer</span>')
                }
                priceList += finPriceItem.replace('{{sku}}', tPrx.data[key].sku).replace('{{header}}', tPrx.data[key].header).replace('{{old_price}}', pricings.data[key].price).replace('{{price}}', tPrx.data[key].price).replace('{{subtext}}', tPrx.data[key].subtext)
            }
            pricingHtml = priceContainer.replace('{{price_list}}', priceList)
        }
        if (pricingHtml.length < 100 || pricingHtml.includes('{{')) {
            throw new Error('incorrect replace object', pricingHtml)
        }
        return pricingHtml
    }
}

module.exports = Pricings
